import React, { useContext } from 'react';
import { ButtonPrimary } from '../../../../Components/StyledComponent';
import { PageTitle } from '../../styles';
import { ContainerNenhumaSolicitacaoCriada } from './style';
import SrcEmptyStateImage from '../../../../assets/novosicones/Sindico/solicitacoes.svg';

import { ContextSindico } from '../../../../services/sindico';

const NenhumaSolicitacaoCriada = ({ functionOnClickNewSolicitation }) => {
  const { tema } = useContext(ContextSindico);
  return (
    <ContainerNenhumaSolicitacaoCriada>
      <img src={SrcEmptyStateImage} />
      <PageTitle>Você não tem nenhuma solicitação criada</PageTitle>
      <p>Clique no botão abaixo e faça a sua solicitação</p>
      <ButtonPrimary
        onClick={functionOnClickNewSolicitation}
        tema={tema}
        id='btnCriarNovaSolicitacao'
      >
        CRIAR NOVA SOLICITAÇÃO
      </ButtonPrimary>
    </ContainerNenhumaSolicitacaoCriada>
  );
};

export default NenhumaSolicitacaoCriada;
